import templateUrl from './report-view.html';

export const reportViewComponent = {
    bindings: {
        details: '<',
        menuName: '@',
        slugUrl: '@',
        parentSlug: '@'
    },

    templateUrl,

    controller: class ReportViewComponent {
        constructor($state, ReportViewService, SlugService) {
            'ngInject';

            this.$state = $state;
            this.reportViewService = ReportViewService;
            this.slugService = SlugService;
        }

        $onInit() {
            this.details = this.reportViewService.getReportDetailsObject(this.details);
            this.isShortDetails = this.menuName === 'ProgressReportsDetails' ? false : true;
        }

        onGoBack() {
            this._redirectToParentState(this.parentSlug);
        }

        onEdit() {
			let slug = this.slugService.removeResourceActionsFromSlugURL(this.slugUrl, 'details');
            let url = this.slugService.getEditPageURL(slug);
            
			this.$state.go('app.dashboard.DynamicMenus', {
				url
			});
		}

        _redirectToParentState(slug) {
			this.$state.go('app.dashboard.DynamicMenus', {
				url: slug
			});
		}
    }
};


// WEBPACK FOOTER //
// ./src/app/components/report-view/report-view.component.js